export default "__VITE_ASSET__DTItqEnc__"